/* Blak Sand — the product-page stream (22 Sep 2026; newest-first 23 Sep 2026).
   Anuj's pdp_stream algorithm, run in the browser from river.json — the
   fortnight's river as the sequencer published it (working pack B7) — with the
   landing shoe removed, four opening positions chosen against it, then the
   river resumed from where she is standing. Deterministic: the seed is the
   cycle seed hashed with the landing shoe, so two women landing on the same
   shoe in the same cycle see the same stream. No live random call anywhere.

   NEWEST-FIRST (23 Sep 2026, decided on the tap-through page): P1 is a nearby
   shape from her own family, newest first — "a Mary Jane pops up" when she's
   on a Ballerina. P2 stays the one guaranteed best-seller seat, unchanged. P3
   is a different family, newest first — "pumps... mixed with others". P4 is
   more of exactly her own silhouette, newest. FAMILY groups by how the shoe
   is worn (flat/dress/boot/mule), same as sequencer.py's family_of(). The
   river itself (G, resumed for the tail) is already newest-first from the
   sequencer's own carried zone, so the tail inherits mixing and the
   best-seller heartbeat for free — nothing below P4 needed to change here.

   HEEL GUARD (22 Sep 2026): when the landing shoe is itself heel-tagged
   (Shopify heel-high / heel-block / fb-heels — bit 8 in river.json's flags,
   set by the sequencer), the three companions that leave the page with her —
   P1, P2 and P4, the ones Meta's retargeting set is built from — are drawn
   only from that same heel pool. A woman who opened a heel never has a flat
   comfort sandal standing next to it. P3 (a different family, shelf-only,
   never in the Meta retarget set) is left unrestricted on purpose. */
(function () {
  'use strict';
  var root = document.querySelector('.bs-stream'); if (!root) return;
  var grid = root.querySelector('ul.bs-shelf'); if (!grid) return;
  var landing = root.dataset.landing, src = root.dataset.src;
  var proofs = []; try { proofs = JSON.parse(root.querySelector('#bsProofs').textContent) || []; } catch (e) {}
  var PAGE = 24;

  var SIL_FAMILY = { ballerina: 'flat', loafer: 'flat', sandal: 'flat', flat: 'flat', heel: 'dress', wedge: 'dress', boot: 'boot', mule: 'mule' };
  function silFamOf(s) { return SIL_FAMILY[s] || s; }

  function famOf(n) {
    n = String(n || '').toLowerCase();
    if (/silver|pewter|chrome/.test(n)) return 'silver';
    if (/gold|bronze|copper|platinum|champagne|brass/.test(n)) return 'gold';
    if (/black/.test(n)) return 'black';
    if (/burgundy|maroon|wine|oxblood|red|plum|cherry|rust/.test(n)) return 'red';
    if (/tan|camel|cognac|caramel|honey|natural|nude/.test(n)) return 'tan';
    if (/brown|chocolate|chestnut|tobacco|mocha|taupe|coffee/.test(n)) return 'brown';
    if (/white|ivory|beige|cream|off white|pearl|sand/.test(n)) return 'white/ivory';
    if (/green|olive|emerald|teal|sage/.test(n)) return 'green';
    if (/blue|navy|denim|sky/.test(n)) return 'blue';
    if (/pink|rose|blush|lilac|purple|violet/.test(n)) return 'pink';
    return '';
  }
  var herColour = '';
  try {
    var swOn = document.querySelector('#bsSwatches [aria-checked="true"]');
    herColour = (swOn && swOn.dataset.value) || new URLSearchParams(location.search).get('c') || '';
  } catch (e) {}
  var herFam = famOf(herColour);
  function hrefFor(r) {
    var u = '/products/' + esc(r.h);
    if (!herFam || !r.c || r.c.length < 2) return u;
    for (var i = 0; i < r.c.length; i++) if (famOf(r.c[i]) === herFam) return u + '?c=' + encodeURIComponent(r.c[i]);
    return u;
  }

  function H() {
    var s = Array.prototype.slice.call(arguments).join('|');
    var h = 0x811c9dc5;
    var bytes = new TextEncoder().encode(s);
    for (var i = 0; i < bytes.length; i++) { h ^= bytes[i]; h = Math.imul(h, 0x01000193) >>> 0; }
    return h >>> 0;
  }

  function okSil(c, prev) {
    if (prev.length && c.s === prev[prev.length - 1].s) return false;
    var w = prev.slice(-4).concat([c]), n = {};
    for (var i = 0; i < w.length; i++) { n[w[i].s] = (n[w[i].s] || 0) + 1; if (n[w[i].s] >= 3) return false; }
    return true;
  }
  function okVal(c, prev) { return !prev.length || c.v !== prev[prev.length - 1].v; }
  function okFin(c, prev) { return !prev.length || c.fi !== prev[prev.length - 1].fi; }
  function okCol(c, prev, target) {
    if (!prev.length) return true;
    var fam = prev[prev.length - 1].f, run = 0;
    for (var i = prev.length - 1; i >= 0 && prev[i].f === fam; i--) run++;
    return run < target ? c.f === fam : c.f !== fam;
  }
  function passes(c, prev, level, target) {
    if (!okSil(c, prev)) return false;
    if (level < 3 && !okCol(c, prev, target)) return false;
    if (level < 2 && !okVal(c, prev)) return false;
    if (level < 1 && !okFin(c, prev)) return false;
    return true;
  }
  function firstFit(pool, prev, maxLevel, target) {
    for (var level = 0; level <= maxLevel; level++)
      for (var i = 0; i < pool.length; i++) if (passes(pool[i], prev, level, target)) return pool[i];
    return null;
  }
  function byScore(a, b) { return (b.sc - a.sc) || (a.h < b.h ? -1 : 1); }
  // NEWEST-FIRST (23 Sep): each row's `published` field (river_asset.json's new
  // 11th column, YYYYMMDD) is what "best" means for P1/P3/P4 now, via byNew()
  // defined inside build() below — kept there because `pd` on the row objects
  // is already taken (the formatted rupee string the cards display).

  function rupees(n) { var s = String(Math.round(n)), last = s.slice(-3), rest = s.slice(0, -3); return '₹' + (rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' : '') + last; }
  function build(data) {
    var seed = data.seed, pre = data.pre || '';
    var SIL = { H: 'heel', S: 'sandal', B: 'ballerina', L: 'loafer', T: 'boot', M: 'mule', W: 'wedge' };
    var VAL = { l: 'light', m: 'mid', d: 'dark' }, FIN = { m: 'matte', M: 'metallic', s: 'suede' };
    var G = data.river.map(function (x, i) {
      return { h: x[0], t: x[1], p: x[2], img: x[3] ? pre + x[3] + '?width=600' : '', pd: rupees(x[2]),
        c: x[4] ? x[4].split('|') : [], s: SIL[x[5].charAt(0)], v: VAL[x[5].charAt(1)], fi: FIN[x[5].charAt(2)], f: x[6],
        a: !!(x[7] & 4), o: !!(x[7] & 2), u: !!(x[7] & 1), hp: !!(x[7] & 8), d: x[8], sc: x[9], pos: i + 1 };
    });
    // `pd` above is the formatted rupee string the cards display, so the publish
    // date (river row's 11th field, x[10]) is read onto its own `published` key
    // instead of colliding with it.
    G.forEach(function (r, i) { r.published = data.river[i][10]; });
    function byNew(a, b) { return (b.published - a.published) || (a.h < b.h ? -1 : 1); }
    var L = null, posL = -1;
    for (var i = 0; i < G.length; i++) if (G[i].h === landing) { L = G[i]; posL = i; }
    if (!L) { L = { h: landing, s: root.dataset.sil || 'heel', f: root.dataset.fam || 'black', v: root.dataset.val || 'mid', fi: root.dataset.fin || 'matte', p: parseFloat(root.dataset.price || '0'), hp: root.dataset.heelpool === 'true' }; posL = -1; }
    var Lheel = (typeof L.hp === 'boolean') ? L.hp : (root.dataset.heelpool === 'true');
    var Lfam = silFamOf(L.s);
    var s = H(seed, landing);
    var used = {}; used[L.h] = true;
    var out = [];
    var Gp = G.filter(function (r) { return r.h !== L.h; });
    var GpH = Lheel ? Gp.filter(function (r) { return r.hp; }) : Gp;
    function take(r) { out.push(r); used[r.h] = true; }

    function spread(pool, tag) {
      var k = Math.min(8, pool.length);
      if (k <= 1) return pool;
      var i = H(s, tag) % k;
      return pool.slice(i, k).concat(pool.slice(0, i), pool.slice(k));
    }
    // P1: a different silhouette, same family, newest. Unconstrained (as before 23 Sep) —
    // only P2 onward run firstFit against L and each other.
    var pool = spread(GpH.filter(function (r) { return r.s !== L.s && silFamOf(r.s) === Lfam; }).sort(byNew), 'p1');
    if (!pool.length) pool = spread(GpH.filter(function (r) { return r.s !== L.s; }).sort(byNew), 'p1');
    take(pool[0] || GpH[0] || Gp[0]);
    // P2: an anchor, one of the eight strongest — the one guaranteed best-seller seat
    pool = spread(GpH.filter(function (r) { return r.a && !used[r.h]; }).sort(byScore), 'p2');
    take(firstFit(pool, [L, out[0]], 2, 4) || pool[0] || (GpH.filter(function (r) { return !used[r.h]; })[0]));
    // P3: a shape from a DIFFERENT family, newest first
    var otherFams = ['flat', 'dress', 'boot', 'mule'].filter(function (f) { return f !== Lfam; });
    var pool3 = [];
    otherFams.forEach(function (fam) {
      pool3 = pool3.concat(spread(Gp.filter(function (r) { return silFamOf(r.s) === fam && !used[r.h]; }).sort(byNew), 'p3' + fam));
    });
    // P4: same silhouette as L, newest first
    var same = spread(GpH.filter(function (r) { return r.s === L.s && !used[r.h]; }).sort(byNew), 'p4');
    var p3 = firstFit(pool3, out.slice(-2), 2, 4);
    if (!p3 || p3.s === L.s) {
      if (same.length) take(same[0]);
      var pool3Left = pool3.filter(function (r) { return !used[r.h]; });
      p3 = firstFit(pool3Left, out.slice(-2), 2, 4) || pool3Left[0];
      if (p3) take(p3);
    } else {
      take(p3);
      var p4 = same.filter(function (r) { return !used[r.h]; })[0];
      if (p4) take(p4);
    }

    var viewed = {};
    try { (JSON.parse(localStorage.getItem('bs-recent') || '[]')).forEach(function (x) { viewed[x.handle] = true; }); } catch (e) {}
    var anchorsAhead = [], carriedAhead = [];
    var N = G.length, start = posL >= 0 ? posL + 1 : 0;
    for (var k = 0; k < N; k++) {
      var r = G[(start + k) % N];
      if (used[r.h] || r.h === L.h) continue;
      (r.a ? anchorsAhead : carriedAhead).push(r);
    }
    var beats = Math.floor((N - 1 - out.length) / 6.5);
    if (anchorsAhead.length > beats) {
      var demote = anchorsAhead.slice().sort(byScore).slice(beats), dm = {};
      demote.forEach(function (r) { dm[r.h] = true; });
      var keep = [], merged = [];
      for (var k2 = 0; k2 < N; k2++) {
        var r2 = G[(start + k2) % N];
        if (used[r2.h] || r2.h === L.h) continue;
        if (r2.a && !dm[r2.h]) keep.push(r2); else merged.push(r2);
      }
      anchorsAhead = keep; carriedAhead = merged;
    }
    var nextAnchor = 2 + (6 + (H(s, 'blk', 0) % 2)), block = 0, carriedTaken = 0;
    var target = function () { return 4 + (H(s, 'run', out.length) % 2); };
    var guard = 0;
    while (out.length < N - 1 && guard++ < 4 * N) {
      var pos = out.length + 1;
      var chosen = null;
      if (pos >= nextAnchor && anchorsAhead.length) {
        chosen = firstFit(anchorsAhead, out, 3, target());
        if (chosen) { anchorsAhead.splice(anchorsAhead.indexOf(chosen), 1); block++; nextAnchor = pos + (6 + (H(s, 'blk', block) % 2)); }
        else { nextAnchor = pos + 1; }
      }
      if (!chosen) {
        var window12 = carriedAhead.slice(0, 12).filter(function (r) { return viewed[r.h]; });
        chosen = firstFit(window12, out, 3, target());
        if (!chosen && carriedTaken < 12) chosen = firstFit(carriedAhead.slice(0, 40), out, 3, target());
        if (!chosen) chosen = firstFit(carriedAhead.slice(0, 40), out, 3, target()) || firstFit(carriedAhead, out, 3, target());
        if (chosen) carriedTaken++;
        if (chosen) carriedAhead.splice(carriedAhead.indexOf(chosen), 1);
        else if (anchorsAhead.length) { chosen = firstFit(anchorsAhead, out, 3, target()); if (chosen) anchorsAhead.splice(anchorsAhead.indexOf(chosen), 1); }
      }
      if (!chosen) {
        chosen = carriedAhead.shift() || anchorsAhead.shift();
        if (!chosen) break;
      }
      take(chosen);
    }

    var cards = [];
    if (proofs.length) {
      var cold = isCold();
      var ci = 0, p = 0;
      if (cold) { p = 3 + (H(s, 'cold') % 2); cards.push({ at: p, card: matchCard(L) }); ci = 1; }
      var prevCard = cards.length ? cards[0].card : null;
      while (p < out.length) {
        p += 12 + (H(s, 'card', ci) % 5);
        var next = proofs[ci % proofs.length];
        if (next === prevCard && proofs.length > 1) next = proofs[(ci + 1) % proofs.length];
        cards.push({ at: p, card: next }); prevCard = next; ci++;
      }
      cards = cards.map(function (c) { var at = c.at; while (at < out.length - 1 && (out[at - 1].a || out[at].a)) at++; c.at = at; return c; });
    }
    return { out: out, cards: cards };
  }
  function isCold() {
    try {
      if (sessionStorage.getItem('bs-seen')) return false;
    } catch (e) {}
    var ref = document.referrer || '', q = location.search;
    if (/utm_source=(fb|ig|facebook|instagram|meta|paid)|fbclid=|gclid=/i.test(q)) return true;
    if (/facebook\.|instagram\.|fb\.me|l\.instagram/i.test(ref)) return true;
    if (!ref) return true;
    return !new RegExp('^https?://' + location.host.replace('.', '\\.')).test(ref);
  }
  // Metallic cards (26 Sep 2026, Anuj): a woman landing cold on a metallic shoe sees
  // a metallic card first, not the suede one. The four metallics (soft sheep, crease,
  // scuffed, micro dot) sit between the suede and nappa cards in the block order, so
  // the cycle below never shows the same card twice before all seven have shown.
  function matchCard(L) {
    var t = (root.dataset.title || '').toLowerCase();
    var want = /suede|camoscio|velluto/.test(t) || L.fi === 'suede' ? 'suede'
      : (L.fi === 'metallic' || /metallic|gold|silver|\boro\b|argent|dorad|aurea|bronze|platinum/.test(t) ? 'metallic'
      : (/nappa|napa|lamb/.test(t) ? 'nappa' : ''));
    for (var i = 0; i < proofs.length; i++) {
      var pt = (proofs[i].title || '').toLowerCase();
      if (want === 'suede' && /suede/.test(pt)) return proofs[i];
      if (want === 'metallic' && /metallic/.test(pt)) return proofs[i];
      if (want === 'nappa' && /nappa|napa/.test(pt)) return proofs[i];
    }
    return proofs[0];
  }

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function card(r, eager) {
    var sw = '';
    if (r.c && r.c.length > 1) {
      sw = '<span class="bs-card__sw" aria-label="' + r.c.length + ' colours">' + r.c.slice(0, 6).map(function (v) { return '<i data-c="' + esc(v) + '" title="' + esc(v) + '"></i>'; }).join('') + (r.c.length > 6 ? '<b>+' + (r.c.length - 6) + '</b>' : '') + '</span>';
    }
    return '<li><a class="bs-card" href="' + hrefFor(r) + '" data-bs-handle="' + esc(r.h) + '"><span class="bs-card__fr"><img src="' + esc(r.img) + '" alt="' + esc(r.t) + '" loading="' + (eager ? 'eager' : 'lazy') + '" width="600" height="900"></span><span class="bs-card__nm">' + esc(r.t) + '</span><span class="bs-card__pr">' + esc(r.pd) + '</span>' + sw + '</a></li>';
  }
  function proofCard(c) {
    return '<li class="bs-proof"><a class="bs-proof__a" href="' + esc(c.url || '#') + '"><span class="bs-proof__fr">' + (c.image ? '<img src="' + esc(c.image) + '" alt="' + esc(c.title) + '" loading="lazy">' : '') + '</span><span class="bs-proof__tx"><span class="bs-proof__k">' + esc(c.kicker || "What you're wearing") + '</span><span class="bs-proof__t">' + esc(c.title) + '</span><span class="bs-proof__l">' + esc(c.text || '') + '</span>' + (c.product ? '<span class="bs-proof__p">' + esc(c.product) + '</span>' : '') + '</span></a></li>';
  }
  var stream = null, shown = 0;
  function renderMore() {
    if (!stream) return;
    var html = '';
    var end = Math.min(shown + PAGE, stream.out.length);
    for (var i = shown; i < end; i++) {
      html += card(stream.out[i], i < 2);
      stream.cards.forEach(function (c) { if (c.at === i + 1) html += proofCard(c.card); });
    }
    grid.insertAdjacentHTML('beforeend', html);
    shown = end;
    var more = root.querySelector('.bs-more');
    if (more && shown >= stream.out.length) more.setAttribute('data-done', 'true');
  }
  var more = root.querySelector('.bs-more');
  if (more) more.addEventListener('click', function (e) { if (e.target.closest('.bs-more__btn')) { e.preventDefault(); renderMore(); } });
  var sentinel = root.querySelector('.bs-sentinel');
  if (sentinel && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting && stream && shown < stream.out.length) renderMore(); }, { rootMargin: '600px 0px' }).observe(sentinel);

  var PLACE = 'bs-stream:' + landing, wanted = 0;
  try { wanted = parseInt(sessionStorage.getItem(PLACE) || '0', 10) || 0; } catch (e) {}
  grid.addEventListener('click', function (e) { if (e.target.closest('a.bs-card')) { try { sessionStorage.setItem(PLACE, String(shown)); } catch (x) {} } });

  fetch(src, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (data) {
    stream = build(data);
    renderMore();
    while (shown < Math.min(wanted, stream.out.length)) renderMore();
    try { sessionStorage.setItem('bs-seen', '1'); } catch (e) {}
  }).catch(function () { root.hidden = true; });
})();
